module.exports = __webpack_public_path__ + "img/lv_get.fa460b3.png";